import {ConditionalAmountNode} from "#pricing/nodes/conditional-amount-node"
import {PricingListNode, pricingListDefinition} from "#pricing/pricing-list-node"
import {registerPricingGraphNode} from "#pricing/pricing-node"
import {z} from "zod/v4-mini"

const conditionalAmountListDefinition = pricingListDefinition("ConditionalAmountList", ConditionalAmountNode, z.number())

@registerPricingGraphNode
export class ConditionalAmountList extends PricingListNode<ConditionalAmountNode> {
    public override get definition() {
        return conditionalAmountListDefinition
    }
}
